import React from 'react';
import './CryptoNavSidebar.css';

interface CryptoNavSidebarProps {
  selectedSubCategory: string;
  onSubCategoryChange: (sub: string) => void;
}

const ICONS: Record<string, React.ReactNode> = {
  All: (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none"><rect x="3" y="3" width="7" height="7" rx="2" fill="#111"/><rect x="14" y="3" width="7" height="7" rx="2" fill="#111"/><rect x="3" y="14" width="7" height="7" rx="2" fill="#111"/><rect x="14" y="14" width="7" height="7" rx="2" fill="#111"/></svg>
  ),
  '15M': (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#111" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><path d="M12 6v6l3 3"/></svg>
  ),
  '1H': (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#111" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><path d="M12 7v5h4"/></svg>
  ),
  '4H': (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#111" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><path d="M12 5v7h6"/></svg>
  ),
  Daily: (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#111" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>
  ),
  Weekly: (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#111" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M3 12h4l2 4 3-8 2 4h7"/></svg>
  ),
  Monthly: (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#111" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M4 14c3-6 13-6 16 0"/><path d="M9 18h6"/><path d="M12 6v2"/></svg>
  ),
  'Pre-Market': (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#111" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M3 12h18"/><path d="M7 8l4-4 4 4"/></svg>
  ),
  ETF: (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#111" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="7" width="18" height="10" rx="2"/><path d="M7 7v10"/><path d="M17 7v10"/></svg>
  ),
};

const CryptoNavSidebar: React.FC<CryptoNavSidebarProps> = ({ selectedSubCategory, onSubCategoryChange }) => {
  const isActive = (sub: string) => selectedSubCategory === sub;
  const SUBS = ['15M', '1H', '4H', 'Daily', 'Weekly', 'Monthly', 'Pre-Market', 'ETF'];

  return (
    <div className="crypto-sidebar">
      <div
        className={`crypto-sidebar-item ${selectedSubCategory === '' ? 'active' : ''}`}
        onClick={() => {
          onSubCategoryChange('');
          try { (window as any).posthog?.capture('engagement:secondary_category_selected', { category: 'Crypto', sub_category: 'All' }); } catch {}
        }}
      >
        <div className="crypto-item-left">
          <span className="crypto-icon">{ICONS['All']}</span>
          <span className="crypto-label">All</span>
        </div>
      </div>

      {SUBS.map(sub => (
        <div
          key={sub}
          className={`crypto-sidebar-item ${isActive(sub) ? 'active' : ''}`}
          onClick={() => {
            onSubCategoryChange(sub);
            try { (window as any).posthog?.capture('engagement:secondary_category_selected', { category: 'Crypto', sub_category: sub }); } catch {}
          }}
        >
          <div className="crypto-item-left">
            <span className="crypto-icon">{ICONS[sub] || null}</span>
            <span className="crypto-label">{sub}</span>
          </div>
        </div>
      ))}
    </div>
  );
};

export default CryptoNavSidebar;


